import { useFetchMerchantSpaces, useFetchMySpaces } from "containers/folders/hooks/spaces";

export const useFetchSpaces = (merchantId?: string, isExternalCall?: boolean) => {
    const {
        data: merchantSpaces,
        isFetching: fetchingMerchantSpaces,
        isIdle: isIdleMerchantSpaces,
    } = useFetchMerchantSpaces(merchantId, isExternalCall, {
        enabled: !!merchantId,
    });
    const {
        data: mySpaces,
        isFetching: fetchingMySpaces,
        isIdle: isIdleMySpaces,
    } = useFetchMySpaces(merchantId, isExternalCall, {
        enabled: !!merchantId,
    });
    const merchantSpace = merchantSpaces?.[0];
    const mySpace = mySpaces?.[0];

    return {
        merchantSpace,
        fetchingMerchantSpaces,
        isIdleMerchantSpaces,
        mySpace,
        fetchingMySpaces,
        isIdleMySpaces,
    };
};
